import { render, staticRenderFns } from "./index.vue?vue&type=template&id=00b6da1b&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts&setup=true"
export * from "./index.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./index.vue?vue&type=style&index=0&id=00b6da1b&prod&scoped=true&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=00b6da1b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b6da1b",
  null
  
)

export default component.exports